import type { WebsiteTranslatorSettings } from '../types';

export function checkBackground({
  backgroundColor,
  borderColor,
  renderThumbnailMode = false
}: Partial<WebsiteTranslatorSettings>) {
  if (renderThumbnailMode) {
    return true;
  }

  const hasBackgroundColor =
    !!backgroundColor && backgroundColor !== 'transparent';
  const hasBorderColor = !!borderColor && borderColor !== 'transparent';

  return hasBackgroundColor || hasBorderColor;
}
